export default __webpack_public_path__ + "static/media/Sage's Leggings of the Crumbling Tower.94941c01.jpg";